import React, { Component } from 'react'; 
import AnimakitExpander from "animakit-expander";
import FAQBar from './FAQBar/FAQBar';

class HotelFAQ extends Component {

    state = {
        accordionIndex: 0
    }

    onToggleAccordion = (index) => {
        if (this.state.accordionIndex === index) {
            this.setState({
                accordionIndex: 0
            })
        } else {
            this.setState({
                accordionIndex: index
            })
        }
    }

    render() {
        return (
            <div className={`u-backgroundColorWhite u-borderRadius4`}>
                <FAQBar index={1} onClick={() => this.onToggleAccordion(1)} accordionindex={this.state.accordionIndex}>How do I know my reservation was booked ?</FAQBar>
                <AnimakitExpander expanded={this.state.accordionIndex === 1 ? true : false} align="bottom">
                    <div className={`u-borderBottomNormal u-backgroundColorWhite pt-3 pb-3 pl-4 pr-4`}>
                        <p>You will receive an SMS and email on confirmation of your hotel(s) booking.</p>
                    </div>
                </AnimakitExpander>
                <FAQBar index={2} onClick={() => this.onToggleAccordion(2)} accordionindex={this.state.accordionIndex}>Do I need to confirm my reservation ?</FAQBar>
                <AnimakitExpander expanded={this.state.accordionIndex === 2 ? true : false} align="bottom">
                    <div className={`u-borderBottomNormal u-backgroundColorWhite pt-3 pb-3 pl-4 pr-4`}>
                        <p>There is no need to confirm your reservation. If you still feel you would like to verify that your reservation was made, you can do so by writing to our Customer Support Team or by contacting our customer services team.</p>
                    </div>
                </AnimakitExpander>
                <FAQBar index={3} onClick={() => this.onToggleAccordion(3)} accordionindex={this.state.accordionIndex}>How do I cancel/amend a hotel(s) reservation ?</FAQBar>
                <AnimakitExpander expanded={this.state.accordionIndex === 3 ? true : false} align="bottom">
                    <div className={`u-borderBottomNormal u-backgroundColorWhite pt-3 pb-3 pl-4 pr-4`}>
                        <p>To cancel a booking log in to My Bookings section or call our call center on 1860 200 1000 (all networks)<br/>To amend a booking call our call center on 1860 200 1000 (all networks).</p>
                    </div>
                </AnimakitExpander>
                <FAQBar index={4} onClick={() => this.onToggleAccordion(4)} accordionindex={this.state.accordionIndex}>Is there a cancellation policy for hotel(s) booked on Yatra.com ?</FAQBar>
                <AnimakitExpander expanded={this.state.accordionIndex === 4 ? true : false} align="bottom">
                    <div className={`u-borderBottomNormal u-backgroundColorWhite pt-3 pb-3 pl-4 pr-4`}>
                        <p>The cancellation policy for hotel(s) bookings varies according to hotel(s) and room type. For more information, please check the cancellation policy mentioned next to the price for the room type. If you are cancelling after the check-in date, there will be no refund. In all cases, you'll be charged a standard cancellation fee of Rs. 250 per booking over and above the hotel(s)'s own cancellation charges.</p>
                    </div>
                </AnimakitExpander>
                <FAQBar index={5} onClick={() => this.onToggleAccordion(5)} accordionindex={this.state.accordionIndex}>How do I pay for the gala dinner ?</FAQBar>
                <AnimakitExpander expanded={this.state.accordionIndex === 5 ? true : false} align="bottom">
                    <div className={`u-borderBottomNormal u-backgroundColorWhite pt-3 pb-3 pl-4 pr-4`}>
                        <p>Gala dinner charges which are applicable for Christmas and New Year dates would be extra and payable directly to the hotel(s). Please check with the hotel(s) directly for more information on the same.</p>
                    </div>
                </AnimakitExpander>
            </div>
        );
    }
} 

export default HotelFAQ;


// WEBPACK FOOTER //
// ./src/components/HotelDetail/HotelFAQ/HotelFAQ.js